export default __webpack_public_path__ + "static/media/twitter.bf3223c5.png";